import React from 'react';
import './DottedBox.css';

const DottedBox = () => (
  <div className="DottedBox">
    {/* <p className="DottedBox_content">Get started with CSS styling</p> */}
  </div>
);

export default DottedBox;